import CCColors from '@/Utils/CCColors';
import {isPhone} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: isPhone ? 'column' : 'row',
    flex: 1,
    overflow: 'scroll',
    // height:'93vh'
    // height: '100%',
  },
  mobileContainer: {
    flex: 1,
  },
  left: {
    width: isPhone ? '100%' : 220,
    flexShrink: 0,
    paddingHorizontal: 0,
    paddingTop: 0,
    height: '100%',
    backgroundColor: CCColors.White,
    borderRightWidth: 1,
    borderRightColor: 'rgba(38,35,34,0.1)',
  },
  chessboardContainer: {
    flexDirection: 'column',
    width: isPhone ? '100%' : '92%',
    maxWidth: 620,
  },
  center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FAF6EB',
    padding: 16,
  },
  right: {
    width: isPhone ? '100%' : 300,
    flexShrink: 0,
    padding: 0,
    backgroundColor: CCColors.White,
    borderLeftWidth: 1,
    borderLeftColor: 'rgba(38,35,34,0.1)',
  },
  addNewBox: {
    backgroundColor: CCColors.Primary.Brown,
    padding: 10,
    borderRadius: 8,
  },
  disabled: {
    backgroundColor: CCColors.Grey.Shade200,
    padding: 10,
    borderRadius: 8,
  },
  boardControls: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 580,
    marginTop: 12,
  },
  boardControlsLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  boardControlsRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  controlIcon: {
    width: 34,
    height: 34,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoHintCard: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 7,
    padding: 10,
    borderRadius: 7,
    backgroundColor: '#FFF0C8',
    margin: 12,
    marginBottom: 0,
  },
  movesPanelHeader: {
    padding: 12,
    paddingBottom: 0,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(38,35,34,0.1)',
  },
  evalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    paddingTop: 8,
  },
});
